import React, { useEffect, useState,useRef, forwardRef, useImperativeHandle } from "react";
import QrCodeWithLogo  from 'react-qrcode-logo';
// import html2canvas from 'html2canvas'; // 引入 html2canvas
import './index.less';

const QRCode = forwardRef((props, ref) => {
    const { 
        children,
        qaUrl, 
        size = 200, 
        level = "H", 
        fgColor = "#000000", 
        bgColor = "#ffffff",
        marginSize = 8,
        title,
        imageSettings,
        salce = 1, 
        className,
    } = props;
    const baseWidth = 600;
    const erweimaRef = useRef(null);
    const scaleSize = size * salce / baseWidth;
    // // 下载二维码函数
    // const downloadQRCode = async () => {
    //     if (!erweimaRef.current) return;
        
    //     try {
    //         // const canvas = qrRef.current.querySelector('canvas');
    //         // if (!canvas) return; 

    //         console.log(erweimaRef.current)

    //         const canvas = await html2canvas(erweimaRef.current, {
    //             useCORS: true, // 允许跨域图片
    //             scale: 1 // 提高图片质量
    //         });
    //         console.log(canvas)
    //         const url = canvas.toDataURL('image/png');
    //         const link = document.createElement('a');
    //         link.href = url;
    //         link.download = filename;
    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);
    //     } catch (error) {
    //         console.error('下载二维码失败:', error);
    //     }
    // };

    // // 暴露给父组件的方法
    // useImperativeHandle(ref, () => ({
    //     downloadQRCode
    // }));

  
    return (
        <div className={`erweima ${className}`} ref={erweimaRef} >
            <div className="erweima-img">
                <QrCodeWithLogo  
                    value={qaUrl}           // 需要生成二维码的内容
                    size={size?(size - marginSize*2)*salce:'100%'}             // 二维码尺寸
                    ecLevel={level||'H'}           // 纠错等级（L/M/Q/H）
                    fgColor={fgColor||'#000000'}       // 二维码颜色
                    bgColor={bgColor||'#fff'}       // 背景颜色
                    quietZone={5} // 边距大小
                    title={title||"二维码"}           // 标题（用于无障碍访问）
                    // logo={imageSettings} // 嵌入图像设置
                    logoImage={imageSettings?.url} // 嵌入图像的 URL
                    logoWidth={imageSettings?.width*scaleSize} // 嵌入图像的宽度（像素）
                    logoHeight={imageSettings?.height*scaleSize} // 嵌入图像的高度（像素）
                    logoPadding = {imageSettings?.padding||'1'} // 嵌入图像的内边距（像素）
                    logoPaddingRadius={imageSettings?.paddingRadius||'1'} // 嵌入图像的内边距半径（像素）
                    logoPaddingStyle={imageSettings?.paddingStyle||'solid'} // 嵌入图像的内边距样式（solid/dashed/dotted）
                    enableCORS={true}
                    key={`${qaUrl}-${size}-${salce}`}
                />
            </div>
            {children}
        </div>
    );
});

export default QRCode;